import { React } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { tokens } from 'theme/tokens';

const ChartContainer = ({
  title,
  width,
  height,
  children,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        height: {height},
        width: {width},
        border: `1px solid ${colors.neutral[200]}`,
        borderRadius: '8px',
        pb: 2,
        gap: 1.5
      }}
    >
      <Box
        sx={{
          height: '50px',
          py:1,
          px:3,
          background: colors.blue[50],
        }}
      >
        <Typography variant='subtitle1' fontWeight={600}>{title}</Typography>
      </Box>
      {children}
    </Box>
  );
};

export default ChartContainer;